import { Injectable, OnInit } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { AuthService } from '../auth.service';
import { CheckoutService } from '../checkout.service';

@Injectable({
  providedIn: 'root'
})

export class CheckoutGuard implements CanActivate, OnInit {


  linkRef: AngularFirestoreCollection<any>;

  link: Observable<any>;


  constructor(private router: Router,private checkout:CheckoutService) { }

  ngOnInit() { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    return new Promise(resolve => {
      if(this.checkout.orderSubInfoLength != 0)
     {
       this.router.navigate(['/checkout-guard'])
       resolve(false)
     } 
     else resolve(true)
    })
  }

}
